import { render, staticRenderFns } from "./new_School_score.vue?vue&type=template&id=6e10175c&scoped=true&"
import script from "./new_School_score.vue?vue&type=script&lang=js&"
export * from "./new_School_score.vue?vue&type=script&lang=js&"
import style0 from "./new_School_score.vue?vue&type=style&index=0&id=6e10175c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10175c",
  null
  
)

export default component.exports